import React, { useEffect, useRef, useState } from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../oms.css";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import Document from "../../../Assets/Images/OMS/Document.svg";
import ShowPDF from "../common/pdfViewer";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { useFormik } from "formik";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from "@mui/icons-material/Image";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import { Box, Button, InputLabel } from "@mui/material";

import axios from "axios";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import { Modal } from "@material-ui/core";

function POBOSSupplierForm({ orderId, poBosUploads, getOMSData, omsData }) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";

  const gstAmount = Number(omsData?.op_sourcing_details?.[0]?.gst_amount || 0);

  const [supplierPoBos, setSupplierPoBos] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [uploadedDocs, setUploadedDocs] = useState({});
  const poInputRef = useRef(null);
  const bosInputRef = useRef(null);
  const invoiceInputRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);

  function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  const initialValues = {
    po: "",
    bos: "",
    invoice: "",
  };
  const validate = (values) => {
    const errors = {};
    if (!values.po) {
      errors.po = "PO Document is Required";
    }
    return errors;
  };

  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

  const handleSubmit = async (values) => {
    const payloadPost = {
      order_id: orderId,
      po_image_pdf_url: values.po ? values.po : null,
      bos_image_pdf_url: values.bos ? values.bos : null,
      invoice_image_pdf_url: values.invoice ? values.invoice : null,
      merchant_type: "supplier",
      is_oms: true,
    };

    const payloadPatch = {
      order_id: orderId,
      po_image_pdf_url: values.po ? values.po : null,
      bos_image_pdf_url: values.bos ? values.bos : null,
      invoice_image_pdf_url: values.invoice ? values.invoice : null,
      merchant_type: "supplier",
      is_oms: true,
    };

    try {
      if (isEmptyObject(uploadedDocs)) {
        const { data } = await axios.post("/api/oms/pos", payloadPost);
        if (data.status) {
          formik.resetForm();
          getOMSData();
          toast.success(data.message);
          if (
            poInputRef.current &&
            bosInputRef.current &&
            invoiceInputRef.current
          ) {
            poInputRef.current.value = ""; // Clear PO file input
            bosInputRef.current.value = ""; // Clear BOS file input
            invoiceInputRef.current.value = "";
          }
        } else {
          toast.error(data.message);
        }
      } else {
        const { data } = await axios.patch("/api/oms/pos", payloadPatch);
        if (data.status) {
          formik.resetForm();
          getOMSData();
          toast.success(data.message);
          if (
            poInputRef.current &&
            bosInputRef.current &&
            invoiceInputRef.current
          ) {
            poInputRef.current.value = ""; // Clear PO file input
            bosInputRef.current.value = ""; // Clear BOS file input
            invoiceInputRef.current.value = "";
          }
        } else {
          toast.error(data.message);
        }
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  const onFileChange = async (event) => {
    const file = event.target.files[0];

    let formData = new FormData();
    formData.append("file", file);
    setUploading(true);
    const uploadResponse = await fetch("/upload/mitra-merchant/doc-upload", {
      method: "POST",
      body: formData,
    });
    if (uploadResponse.ok) {
      const uploadResponseData = await uploadResponse.json();

      if (event.target.name === "po") {
        formik.setFieldValue("po", uploadResponseData.file_location);
      } else if (event.target.name === "bos") {
        formik.setFieldValue("bos", uploadResponseData.file_location);
      } else if (event.target.name === "invoice") {
        formik.setFieldValue("invoice", uploadResponseData.file_location);
      }
      setUploading(false);
    } else {
      setUploading(false);
      throw new Error("Failed to upload file.");
    }
  };

  useEffect(() => {
    const buyerDoc = poBosUploads?.find(
      (obj) => obj.merchant_type === "supplier"
    );

    if (buyerDoc) {
      setUploadedDocs(buyerDoc);

      formik.setValues({
        ...formik.values,
        po: buyerDoc.po_image_pdf_url || "",
        bos: buyerDoc.bos_image_pdf_url || "",
        invoice: buyerDoc.invoice_image_pdf_url || "",
      });
    }
  }, [poBosUploads, formik.setValues]);

  return (
    <>
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>

      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex justify-normal gap-1">
            <InsertDriveFileIcon />
            <div>Supplier's PO and BOS</div>
          </div>
          <div>
            {supplierPoBos ? (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() => setSupplierPoBos(!supplierPoBos)}
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() => setSupplierPoBos(!supplierPoBos)}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {supplierPoBos ? (
            <></>
          ) : (
            <div>
              <div className="mb-2">
                <h1 className="text-sm mb-2 text-blue-900">
                  Uploaded Documents
                </h1>
                <div>
                  <div className="row mx-5">
                    <div className="col col-md-4 col-lg-4 col-sm-4 col-sm-4">
                      <div className="border-2 rounded p-2 bg-gray-300">
                        <div className="flex justify-center gap-2 me-5 mb-2">
                          <img src={Document} alt="" />
                          <InputLabel className="text-black mt-2">
                            PO
                          </InputLabel>
                        </div>
                        {(uploadedDocs?.po_image_pdf_url
                          ?.toLowerCase()
                          .endsWith(".jpg") ||
                          uploadedDocs?.po_image_pdf_url
                            ?.toLowerCase()
                            .endsWith(".png") ||
                          uploadedDocs?.po_image_pdf_url
                            ?.toLowerCase()
                            .endsWith(".jpeg")) && (
                          <div>
                            <ImageIcon style={{ fontSize: "60px" }} />
                          </div>
                        )}
                        {uploadedDocs?.po_image_pdf_url
                          ?.toLowerCase()
                          .endsWith(".pdf") && (
                          <div>
                            <FileCopyIcon style={{ fontSize: "60px" }} />
                          </div>
                        )}
                        <div className="mt-1 p-2">
                          {uploadedDocs?.po_image_pdf_url ? (
                            <div className="">
                              <button
                                className="bg-blue-500 text-white rounded p-2 mr-2"
                                onClick={() =>
                                  handleModalOpen(
                                    uploadedDocs?.po_image_pdf_url
                                  )
                                }
                              >
                                View
                              </button>
                              <button className="bg-blue-500 text-white rounded p-2">
                                <a
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                  href={uploadedDocs?.po_image_pdf_url}
                                >
                                  Download
                                </a>
                              </button>
                            </div>
                          ) : (
                            <div>
                              <div>
                                <i
                                  class="fa fa-file-pdf-o fs-1 text-secondary"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <span className="p-1 bg-red-200 rounded mb-2">
                                <span style={{ color: "#fc3503" }}>
                                  Not Uploaded
                                </span>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {!gstAmount ? (
                      <div className="col col-md-4 col-lg-4 col-sm-4 col-sm-4">
                        <div className="border-2 rounded p-2 bg-gray-300">
                          <div className="flex justify-center gap-2  me-5 mb-2">
                            <img src={Document} alt="" />
                            <InputLabel className="text-black mt-2">
                              BOS
                            </InputLabel>
                          </div>
                          {(uploadedDocs?.bos_image_pdf_url
                            ?.toLowerCase()
                            .endsWith(".jpg") ||
                            uploadedDocs?.bos_image_pdf_url
                              ?.toLowerCase()
                              .endsWith(".png") ||
                            uploadedDocs?.bos_image_pdf_url
                              ?.toLowerCase()
                              .endsWith(".jpeg")) && (
                            <div>
                              <ImageIcon style={{ fontSize: "60px" }} />
                            </div>
                          )}
                          {uploadedDocs?.bos_image_pdf_url
                            ?.toLowerCase()
                            .endsWith(".pdf") && (
                            <div>
                              <FileCopyIcon style={{ fontSize: "60px" }} />
                            </div>
                          )}
                          <div className="mt-1 p-2">
                            {uploadedDocs?.bos_image_pdf_url ? (
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() =>
                                    handleModalOpen(
                                      uploadedDocs?.bos_image_pdf_url
                                    )
                                  }
                                >
                                  View
                                </button>
                                <button className="bg-blue-500 text-white rounded p-2">
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={uploadedDocs?.bos_image_pdf_url}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            ) : (
                              <div>
                                <div>
                                  <i
                                    class="fa fa-file-pdf-o fs-1 text-secondary"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <span className="p-1 bg-red-200 rounded mb-2">
                                  <span style={{ color: "#fc3503" }}>
                                    Not Uploaded
                                  </span>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {gstAmount ? (
                      <div className="col col-md-4 col-lg-4 col-sm-4 col-sm-4">
                        <div className="border-2 rounded p-2 bg-gray-300">
                          <div className="flex justify-center gap-2  me-5 mb-2">
                            <img src={Document} alt="" />
                            <InputLabel className="text-black mt-2">
                              Invoice
                            </InputLabel>
                          </div>
                          {(uploadedDocs?.invoice_image_pdf_url
                            ?.toLowerCase()
                            .endsWith(".jpg") ||
                            uploadedDocs?.invoice_image_pdf_url
                              ?.toLowerCase()
                              .endsWith(".png") ||
                            uploadedDocs?.invoice_image_pdf_url
                              ?.toLowerCase()
                              .endsWith(".jpeg")) && (
                            <div>
                              <ImageIcon style={{ fontSize: "60px" }} />
                            </div>
                          )}
                          {uploadedDocs?.invoice_image_pdf_url
                            ?.toLowerCase()
                            .endsWith(".pdf") && (
                            <div>
                              <FileCopyIcon style={{ fontSize: "60px" }} />
                            </div>
                          )}
                          <div className="mt-1 p-2">
                            {uploadedDocs?.invoice_image_pdf_url ? (
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() =>
                                    handleModalOpen(
                                      uploadedDocs?.invoice_image_pdf_url
                                    )
                                  }
                                >
                                  View
                                </button>
                                <button className="bg-blue-500 text-white rounded p-2">
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={uploadedDocs?.invoice_image_pdf_url}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            ) : (
                              <div>
                                <div>
                                  <i
                                    class="fa fa-file-pdf-o fs-1 text-secondary"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <span className="p-1 bg-red-200 rounded mb-2">
                                  <span style={{ color: "#fc3503" }}>
                                    Not Uploaded
                                  </span>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div>
                <h1 className="text-sm mb-2 text-blue-900">Upload Documents</h1>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row mx-5">
                    <div className="col col-md-4 col-lg-4 col-sm-4 col-sm-4">
                      <div className="border-2 rounded p-2 bg-gray-300">
                        <div className="flex justify-center gap-2  me-5 mb-4">
                          <img src={Document} alt="" />
                          <InputLabel className="text-black mt-2">
                            PO
                          </InputLabel>
                        </div>
                        <div>
                          <input
                            id="file"
                            type="file"
                            name="po"
                            ref={poInputRef}
                            onChange={(e) => onFileChange(e)}
                            disabled={isPending || uploading}
                          />
                        </div>
                      </div>

                      {formik.errors.po ? (
                        <div className="text-red-600 text-sm flex justify-start ms-1">
                          {formik.errors.po}
                        </div>
                      ) : null}
                    </div>

                    {!gstAmount ? (
                      <div className="col col-md-4 col-lg-4 col-sm-4 col-sm-4">
                        <div className="border-2 rounded p-2 bg-gray-300">
                          <div className="flex justify-center gap-2  me-5 mb-4">
                            <img src={Document} alt="" />
                            <InputLabel className="text-black mt-2">
                              BOS
                            </InputLabel>
                          </div>
                          <div>
                            <input
                              id="file"
                              type="file"
                              name="bos"
                              ref={bosInputRef}
                              onChange={(e) => onFileChange(e)}
                              disabled={isPending || uploading}
                            />
                          </div>
                        </div>
                        {formik.errors.bos ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.bos}
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {gstAmount ? (
                      <div className="col col-md-4 col-lg-4 col-sm-4 col-sm-4">
                        <div className="border-2 rounded p-2 bg-gray-300">
                          <div className="flex justify-center gap-2  me-5 mb-4">
                            <img src={Document} alt="" />
                            <InputLabel className="text-black mt-2">
                              Invoice
                            </InputLabel>
                          </div>
                          <div>
                            <input
                              id="file"
                              type="file"
                              name="invoice"
                              ref={invoiceInputRef}
                              onChange={(e) => onFileChange(e)}
                              disabled={isPending || uploading}
                            />
                          </div>
                        </div>
                        {formik.errors.invoice ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.invoice}
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    {uploading ? (
                      <div>
                        <ClipLoader />
                      </div>
                    ) : (
                      <div className="flex justify-end mt-2">
                        <Button
                          variant="contained"
                          size="small"
                          type="submit"
                          sx={{ backgroundColor: "#0D9223" }}
                          disabled={isPending}
                        >
                          SAVE
                        </Button>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default POBOSSupplierForm;
